import { StatusBadge } from "@nymbl/nos2-rules";
import { APPROVAL_TONES, PAYMENT_TONES } from "@/components/expenses/expense-colors";
import type { ApprovalStatus, PaymentStatus } from "@/lib/expenses/rules";
import { approvalLabel, NO_APPROVER, paymentLabel } from "@/lib/expenses/view";

export function ApprovalChip({
  status,
  noApprover = false,
}: {
  status: ApprovalStatus | null;
  noApprover?: boolean;
}) {
  if (!status) return null;
  return (
    <span className="flex flex-col items-start gap-1">
      <StatusBadge
        status={status}
        tones={APPROVAL_TONES}
        labels={{ [status]: approvalLabel(status) }}
      />
      {noApprover && <span className="text-xs text-danger">{NO_APPROVER}</span>}
    </span>
  );
}

export function PaymentChip({
  status,
  approval,
}: {
  status: PaymentStatus | null;
  approval: ApprovalStatus | null;
}) {
  if (!status) return null;
  return (
    <StatusBadge
      status={status}
      tones={PAYMENT_TONES}
      labels={{ [status]: paymentLabel(status, approval) }}
    />
  );
}
